import { Fetch } from 'lib/Fetch';

export function changePasswordUserService({
  oldPassword,
  password1,
  password2,
  otp,
}) {
  return new Fetch()
    .url('/user/login/change-password')
    .method('POST')
    .userToken()
    .data({
      oldPassword,
      password1,
      password2,
      otp,
    })
    .send();
}

export function sendCodeEmailUser() {
  return new Fetch()
    .url('/user/login/otp')
    .method('GET')
    .userToken()
    .send();
}
